import * as DOM from "../services/dom";
import {Component} from "./component";

export class ModalButton extends Component {

    setup() {
        this.elem = this.$el;
        this.modalId = this.$opts.modalId;

        this.elem.addEventListener('click', this.show.bind(this));
    }

    show()
    {
        let modal = document.getElementById(this.modalId);
            modal.style.display = "block";

        let span = modal.getElementsByClassName("close")[0];

        let closeModal = modal.getElementsByClassName("close-modal")[0];

        DOM.onEvents(span, ['click'], event => {
            modal.style.display = "none";
        });

        DOM.onEvents(closeModal, ['click'], event => {
            modal.style.display = "none";
        });

        // When the user clicks anywhere outside of the modal, close it
        window.onclick = function(event) {
            if (event.target == modal) {
                modal.style.display = "none";
            }
        }
    }
}
